import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CoverArtPlaceholder } from 'components/CoverArtPlaceholder';
import { CoverArtModalScreenContainer } from 'screens/CoverArtModalScreen';
import actions from 'screens/CoverArtModalScreen/duck/actions';
import { trackUpdateCoverArtClick } from 'screens/SettingsScreen/events';
import { ButtonPrimary, IconDownloadAlt } from '@spotify-internal/encore-web';
import { useT } from 'client/i18n/hooks/useT';
import {
  ButtonWrapper,
  ImageUploadButtonContainer,
  Container,
  ImageUploadParagraph,
  ImageWrapper,
  DownloadButton,
} from './styles';

export function PodcastCoverArt({
  podcastImage,
  podcastImageFull,
}: {
  podcastImage?: string;
  podcastImageFull?: string;
}) {
  const t = useT();
  const dispatch = useDispatch();
  const [displayImage, setDisplayImage] = useState<string | undefined>(
    undefined
  );
  const [downloadImage, setDownloadImage] = useState<string | undefined>(
    undefined
  );
  const [isShowingModal, setIsShowingModal] = useState<boolean>(false);

  useEffect(() => {
    setDisplayImage(podcastImage || podcastImageFull);
    setDownloadImage(podcastImageFull || podcastImage);
  }, [podcastImage, podcastImageFull]);

  useEffect(() => {
    dispatch(actions.setIsShowing(isShowingModal));
  }, [isShowingModal]);

  return (
    <>
      <Container>
        <ImageWrapper>
          {displayImage ? (
            <img
              src={displayImage}
              alt={t(
                'SettingsScreen.EncoreSettingsForm.PodcastCoverArt.CoverArtImgAlt',
                'Podcast cover art',
                'Podcast cover art image screenreader information'
              )}
            />
          ) : (
            <CoverArtPlaceholder />
          )}
        </ImageWrapper>
        <ImageUploadButtonContainer>
          <ImageUploadParagraph>
            {t(
              'SettingsScreen.EncoreSettingsForm.PodcastCoverArt.ImageUploadMessage',
              'Upload or search through a catalog of cover art options that best represents your podcast.',
              'Podcast cover art image uploader message'
            )}
          </ImageUploadParagraph>
          <ButtonWrapper>
            <ButtonPrimary
              onClick={() => {
                trackUpdateCoverArtClick();
                setIsShowingModal(true);
              }}
            >
              {t(
                'SettingsScreen.EncoreSettingsForm.PodcastCoverArt.UpdateCoverArtButtonLabel',
                'Update cover art',
                'Update podcast cover art button text'
              )}
            </ButtonPrimary>
            {downloadImage && (
              <DownloadButton
                iconLeading={IconDownloadAlt}
                href={downloadImage}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t(
                  'SettingsScreen.EncoreSettingsForm.PodcastCoverArt.DownloadCoverArtButtonLabel',
                  'Download art',
                  'Download podcast cover art button text'
                )}
              </DownloadButton>
            )}
          </ButtonWrapper>
        </ImageUploadButtonContainer>
      </Container>
      <CoverArtModalScreenContainer
        onWillClose={() => setIsShowingModal(false)}
        onFinishSubmitCoverArt={({
          image400,
          image,
        }: {
          image: string;
          image400: string;
        }) => {
          setDisplayImage(image400);
          setDownloadImage(image);
          setIsShowingModal(false);
        }}
      />
    </>
  );
}
